import { Phone, ArrowRight, Clock, Star } from 'lucide-react';

export const HeroSection = () => {
  return (
    <section className="relative min-h-screen pt-20 lg:pt-0 flex items-center overflow-hidden bg-zinc-950">
      {/* Background Image */}
      <div className="absolute inset-0 lg:left-1/2">
        <img
          src="https://images.pexels.com/photos/9679179/pexels-photo-9679179.jpeg"
          alt="Professional electrician working on electrical panel"
          className="w-full h-full object-cover hero-img"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-zinc-950 via-zinc-950/90 to-zinc-950/40 lg:from-zinc-950 lg:via-zinc-950/80 lg:to-transparent" />
      </div>

      {/* Content */}
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-0 w-full">
        <div className="lg:max-w-2xl">
          {/* Availability Badge */}
          <div className="inline-flex items-center gap-2 availability-badge px-4 py-2 mb-6 animate-fade-in-up" data-testid="availability-badge">
            <Clock className="w-4 h-4" aria-hidden="true" />
            <span className="text-sm font-medium">Open 7 Days a Week • 8 AM - 8 PM</span>
          </div>

          {/* Main Headline */}
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white leading-tight tracking-tight mb-6 animate-fade-in-up animation-delay-100" data-testid="hero-headline">
            Portland's Reliable<br />
            <span className="text-yellow-400">7-Day-a-Week</span> Electricians
          </h1>

          {/* Sub-headline */}
          <p className="text-lg text-zinc-300 mb-8 max-w-xl leading-relaxed animate-fade-in-up animation-delay-200" data-testid="hero-subheadline">
            Safe, professional, and prompt electrical services for your home or business. From panel upgrades to emergency troubleshooting, our licensed experts are here for you 12 hours a day, every day of the week.
          </p>

          {/* Rating */}
          <div className="flex items-center gap-3 mb-8 animate-fade-in-up animation-delay-300">
            <div className="flex items-center gap-1">
              {[1, 2, 3, 4].map((i) => (
                <Star key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" aria-hidden="true" />
              ))}
              <Star className="w-5 h-5 fill-yellow-400/50 text-yellow-400" aria-hidden="true" />
            </div>
            <span className="text-white font-semibold">4.6</span>
            <span className="text-zinc-400">Star Rating</span>
          </div>

          {/* CTAs */}
          <div className="flex flex-col sm:flex-row gap-4 animate-fade-in-up animation-delay-400">
            <a
              href="tel:+19712652635"
              className="btn-primary electric-glow flex items-center justify-center gap-2 px-8 py-4 text-lg font-semibold"
              data-testid="hero-call-button"
            >
              <Phone className="w-5 h-5" aria-hidden="true" />
              Call (971) 265-2635
            </a>
            <a
              href="#contact"
              className="btn-secondary flex items-center justify-center gap-2 px-8 py-4 text-lg font-medium"
              data-testid="hero-quote-button"
            >
              Request a Free Quote
              <ArrowRight className="w-5 h-5" aria-hidden="true" />
            </a>
          </div>

          {/* Trust indicators */}
          <div className="flex flex-wrap gap-6 mt-10 pt-8 border-t border-white/10 animate-fade-in-up animation-delay-500">
            <div className="flex items-center gap-2">
              <div className="w-2 h-2 bg-green-500 rounded-full" />
              <span className="text-sm text-zinc-400">Licensed & Insured</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-2 h-2 bg-green-500 rounded-full" />
              <span className="text-sm text-zinc-400">Free Estimates</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-2 h-2 bg-green-500 rounded-full" />
              <span className="text-sm text-zinc-400">Same Day Service</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
